var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_1514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13.8988 0 11.8183 0.424127 9.87706 1.24817C7.93586 2.0722 6.17203 3.28001 4.68629 4.80264C1.68571 7.87772 0 12.0484 0 16.3972C0 23.6448 4.592 29.7938 10.944 31.9746C11.744 32.1058 12 31.5975 12 31.1547V28.3836C7.568 29.3674 6.624 26.1864 6.624 26.1864C5.888 24.2843 4.848 23.776 4.848 23.776C3.392 22.7594 4.96 22.7922 4.96 22.7922C6.56 22.9069 7.408 24.4811 7.408 24.4811C8.8 26.9734 11.152 26.2356 12.064 25.842C12.208 24.7762 12.624 24.0547 13.072 23.6448C9.52 23.2349 5.792 21.8247 5.792 15.5774C5.792 13.7573 6.4 12.2979 7.44 11.1337C7.28 10.7238 6.72 9.01848 7.6 6.80485C7.6 6.80485 8.944 6.36213 12 8.47737C13.264 8.11663 14.64 7.93626 16 7.93626C17.36 7.93626 18.736 8.11663 20 8.47737C23.056 6.36213 24.4 6.80485 24.4 6.80485C25.28 9.01848 24.72 10.7238 24.56 11.1337C25.6 12.2979 26.208 13.7573 26.208 15.5774C26.208 21.8411 22.464 23.2185 18.896 23.6284C19.472 24.1367 20 25.137 20 26.6619V31.1547C20 31.5975 20.256 32.1222 21.072 31.9746C27.424 29.7774 32 23.6448 32 16.3972C32 14.2439 31.5861 12.1117 30.7821 10.1223C29.978 8.13288 28.7994 6.32526 27.3137 4.80264C25.828 3.28001 24.0641 2.0722 22.1229 1.24817C20.1817 0.424127 18.1012 0 16 0Z",
    fill: "#8B52E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_1514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/githubIcon.7c61e67247bd6f8e606b92228e7d6cfe.svg";
export { ForwardRef as ReactComponent };